module.exports = __webpack_public_path__ + "static/media/spotaward.7adcb684.jpeg";